// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__OnK9e","containerItemsCenter":"Skeleton_containerItemsCenter__2PpZd"};